import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { Box } from '@hivewatch/dark'

import { Notification } from '@/graphql/appsync-notifications'

import { getNotificationToastTokens } from '../styles/tokens'

export const FlagNotificationTitle = ({
  notification,
}: {
  notification: Notification
}) => {
  const { t } = useTranslation()
  const tokens = getNotificationToastTokens(useLightMode())
  return (
    <Box color={tokens.textPrimary} lineClamp={3} textStyle='body-bold'>
      <Box
        as='span'
        color={tokens.incidentLink}
        data-testid='FlagNotificationTitle:title'
      >
        AI Operator{' '}
      </Box>
      {t('common:ai_operator_has_flagged_short')}{' '}
      <Box
        as='span'
        color={tokens.incidentLink}
        data-testid='FlagNotificationTitle:details'
      >
        {notification?.incidentDisplayId} {notification?.incidentName}
      </Box>{' '}
      {t('common:ai_operator_flagged_for_review')}
    </Box>
  )
}
